import { z } from 'zod';

export const surveyLinkParticipantId = z.string().max(32); // limit asserted because of database
export const qualtrixQuestionnaireLink = z.string().max(2048); // limit asserted because of database
export const participantIdsCsvImportRow = z.array(z.string());
